class BESSAppProjectsTimeChart extends BESSAppBase {

    constructor() {
        super()
        this.node = $('.app-projects-time');
        let projectTimeStatsJs = this.node.find('script').text();
        let projectTimeStats = eval(projectTimeStatsJs);
        this.log('projectTimeStats', projectTimeStats);
        this.chartNode = this.node.find('.chart-img');
        this.chartNode.highcharts({
            chart: {
                type: 'column'
            }, plotOptions: {
                area: {
                    marker: {
                        enabled: false,
                    }
                }
            }, xAxis: {
                allowDecimals: false, labels: {
                    formatter: function () {
                        return projectTimeStats[this.pos][0];
                    }
                }
            }, yAxis: {
                title: {
                    enabled: false,
                }, gridLineWidth: 0,
            }, legend: {
                enabled: false,
            }, tooltip: {
                enabled: false,
            }, credits: {
                enabled: false
            }, title: {
                text: null
            }, subtitle: {
                text: null
            }, colors: ["#319AA8",], series: [{
                enableMouseTracking: false,
                opacity: this.isDarkTheme() ? 0.5 : 0.3,
                data: projectTimeStats
            }]
        });
    }
}